import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkModule, MaterialsModule, KeysPipe } from '.';
import { MatSpinnerOverlayComponent, NotFoundComponent, TimeRangePickerComponent, NotAuthorizedComponent } from './components';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StopPropagationDirective } from './directives/stop-propagation.directive';

const Modules = [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, CdkModule, MaterialsModule];
const Components = [MatSpinnerOverlayComponent, NotFoundComponent, TimeRangePickerComponent, NotAuthorizedComponent];
const Directives = [StopPropagationDirective];
const Services = [];
const Pipes = [KeysPipe];

@NgModule({
  declarations: [Components, Pipes, Directives],
  imports: [Modules],
  exports: [Modules, Components, Pipes, Directives],
  providers: [Services],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
